/**
 * Video Carousel Section — standalone JS
 * Extracted from product-detail.js section15 logic
 * Dependencies: Swiper (loaded globally via theme.liquid)
 */
document.addEventListener('DOMContentLoaded', function () {

    /* ----------------------------------------------------------------
     * DOM references
     * ---------------------------------------------------------------- */
    var swiperElement = document.querySelector('.video-carousel-swiper');

    if (!swiperElement) {
        return; /* section not present on this page — nothing to do */
    }

    /* ----------------------------------------------------------------
     * YouTube helpers
     * ---------------------------------------------------------------- */
    function getOrigin() {
        return /^https?:\/\//.test(window.location.origin) ? window.location.origin : '';
    }

    function getEmbedSrc(videoId, autoplay) {
        var params = new URLSearchParams({
            enablejsapi: '1',
            playsinline: '1',
            rel: '0'
        });
        var origin = getOrigin();

        if (origin) {
            params.set('origin', origin);
        }

        if (autoplay) {
            params.set('autoplay', '1');
        }

        return 'https://www.youtube.com/embed/' + videoId + '?' + params.toString();
    }

    function postMessageToPlayer(videoCard, command) {
        var iframe = videoCard.querySelector('iframe');

        if (!iframe || !iframe.contentWindow) {
            return;
        }

        iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: command,
            args: []
        }), '*');
    }

    function pauseVideo(videoCard) {
        videoCard.classList.remove('is-playing');
        videoCard.dataset.autoplayOnReady = 'false';
        postMessageToPlayer(videoCard, 'pauseVideo');
    }

    function ensurePlayer(videoCard, autoplayOnReady) {
        var videoFrame = videoCard.querySelector('.video-carousel-video-frame');
        var existingIframe = videoFrame.querySelector('iframe');
        var videoId = videoCard.dataset.videoId;

        if (autoplayOnReady) {
            videoCard.dataset.autoplayOnReady = 'true';
        }

        if (existingIframe) {
            if (autoplayOnReady && videoCard.dataset.ready === 'true') {
                videoCard.classList.add('is-playing');
                postMessageToPlayer(videoCard, 'playVideo');
            }

            return existingIframe;
        }

        var iframe = document.createElement('iframe');

        iframe.src = getEmbedSrc(videoId);
        iframe.title = 'YouTube video player';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';

        iframe.addEventListener('load', function () {
            videoCard.dataset.ready = 'true';
            videoCard.classList.add('is-ready');

            if (videoCard.dataset.autoplayOnReady === 'true') {
                videoCard.classList.add('is-playing');
                postMessageToPlayer(videoCard, 'playVideo');
                videoCard.dataset.autoplayOnReady = 'false';
            }
        });

        videoFrame.appendChild(iframe);

        return iframe;
    }

    function playVideo(videoCard) {
        ensurePlayer(videoCard, true);

        if (videoCard.dataset.ready === 'true') {
            videoCard.classList.add('is-playing');
            postMessageToPlayer(videoCard, 'playVideo');
            videoCard.dataset.autoplayOnReady = 'false';
        }
    }

    function preloadSlide(swiper, slideIndex) {
        var totalSlides = swiper.slides.length;
        var normalizedIndex = ((slideIndex % totalSlides) + totalSlides) % totalSlides;
        var slide = swiper.slides[normalizedIndex];
        var videoCard = slide ? slide.querySelector('.video-carousel-video') : null;

        if (videoCard) {
            ensurePlayer(videoCard, false);
        }
    }

    function preloadVisibleVideos(swiper) {
        if (!swiper || typeof swiper.activeIndex !== 'number' || !swiper.slides || !swiper.slides.length) {
            return;
        }

        preloadSlide(swiper, swiper.activeIndex);
        preloadSlide(swiper, swiper.activeIndex - 1);
        preloadSlide(swiper, swiper.activeIndex + 1);
    }

    function pauseInactiveVideos(swiper) {
        if (!swiper || !swiper.el || typeof swiper.el.querySelectorAll !== 'function') {
            return;
        }

        Array.from(swiper.el.querySelectorAll('.video-carousel-video')).forEach(function (videoCard) {
            var slide = videoCard.closest('.swiper-slide');

            if (!slide || !slide.classList.contains('swiper-slide-active')) {
                pauseVideo(videoCard);
            }
        });
    }

    /* ----------------------------------------------------------------
     * Swiper initialisation
     * ---------------------------------------------------------------- */
    var swiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 12,
        loop: true,
        loopedSlides: 4,
        initialSlide: 1,
        speed: 600,
        pagination: {
            el: '.video-carousel-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.video-carousel-button-next',
            prevEl: '.video-carousel-button-prev'
        },
        breakpoints: {
            768: {
                spaceBetween: 28
            }
        }
    });

    /* --- Lazy-load & pause management ---------------- */
    preloadVisibleVideos(swiper);
    pauseInactiveVideos(swiper);

    swiper.on('slideChangeTransitionStart', function () {
        pauseInactiveVideos(swiper);
        preloadVisibleVideos(swiper);
    });

    /* --- Click-to-play on active slide --------------- */
    swiperElement.addEventListener('click', function (event) {
        var trigger = event.target.closest('.video-carousel-video-trigger');

        if (!trigger) {
            return;
        }

        var slide = trigger.closest('.swiper-slide');
        var videoCard = trigger.closest('.video-carousel-video');
        var slideIndex = Number(slide.getAttribute('data-swiper-slide-index'));

        if (!swiper || !slide || !videoCard) {
            return;
        }

        /* Clicking a non-active slide → switch to it first */
        if (!slide.classList.contains('swiper-slide-active')) {
            swiper.slideToLoop(slideIndex);
            return;
        }

        playVideo(videoCard);
    });

    /* --- Shopify section-load re-init ---------------- */
    document.addEventListener('shopify:section:load', function (event) {
        var incomingSwiperEl = event.target.querySelector('.video-carousel-swiper');

        if (!incomingSwiperEl || incomingSwiperEl.dataset.videoCarouselInit === 'true') {
            return;
        }

        incomingSwiperEl.dataset.videoCarouselInit = 'true';

        var newSwiper = new Swiper(incomingSwiperEl, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 12,
            loop: true,
            loopedSlides: 4,
            initialSlide: 1,
            speed: 600,
            pagination: {
                el: incomingSwiperEl.querySelector('.video-carousel-pagination'),
                clickable: true
            },
            navigation: {
                nextEl: incomingSwiperEl.querySelector('.video-carousel-button-next'),
                prevEl: incomingSwiperEl.querySelector('.video-carousel-button-prev')
            },
            breakpoints: {
                768: {
                    spaceBetween: 28
                }
            }
        });

        preloadVisibleVideos(newSwiper);
        pauseInactiveVideos(newSwiper);

        newSwiper.on('slideChangeTransitionStart', function () {
            pauseInactiveVideos(newSwiper);
            preloadVisibleVideos(newSwiper);
        });

        incomingSwiperEl.addEventListener('click', function (event) {
            var trigger = event.target.closest('.video-carousel-video-trigger');

            if (!trigger) {
                return;
            }

            var slide = trigger.closest('.swiper-slide');
            var videoCard = trigger.closest('.video-carousel-video');
            var slideIndex = Number(slide.getAttribute('data-swiper-slide-index'));

            if (!newSwiper || !slide || !videoCard) {
                return;
            }

            if (!slide.classList.contains('swiper-slide-active')) {
                newSwiper.slideToLoop(slideIndex);
                return;
            }

            playVideo(videoCard);
        });
    });

});
